import angular from "angular";

angular
    .module('ui-sentinel.accounts')
    .constant('TrackingConfigConstants', {
        'DEFAULT_URL': 'https://oainsight2.onasset.com/track/'
    });
